/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

const Embed = styled.div`
  &::before {
    padding-top: 56.25%;
    display: block;
    content: '';
  }

  iframe {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 0;
  }
`;

export { Embed };
